import React, { useState, useEffect } from 'react';
import { db } from '../firebase';
import { collection, getDocs } from 'firebase/firestore';
import { GoogleMap, Marker, LoadScript } from '@react-google-maps/api';
import { Link } from 'react-router-dom';

const TransportOffersPage = () => {
  const [transportOffers, setTransportOffers] = useState([]);
  const [filteredOffers, setFilteredOffers] = useState([]);
  const [currentLocation, setCurrentLocation] = useState('');
  const [destination, setDestination] = useState('');
  const [type, setType] = useState('');
  const [mapCenter, setMapCenter] = useState({ lat: 37.7749, lng: -122.4194 });
  const [mapZoom, setMapZoom] = useState(10);

  useEffect(() => {
    const fetchTransportOffers = async () => {
      const offersRef = collection(db, 'transportOffers');
      const querySnapshot = await getDocs(offersRef);
      const offersList = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setTransportOffers(offersList);
      setFilteredOffers(offersList); // عرض جميع العروض في البداية
    };

    fetchTransportOffers();
  }, []);

  useEffect(() => {
    const filtered = transportOffers.filter((offer) => {
      return (
        (currentLocation === '' || offer.origin.toLowerCase().includes(currentLocation.toLowerCase())) &&
        (destination === '' || offer.destination.toLowerCase().includes(destination.toLowerCase())) &&
        (type === '' || offer.type === type)
      );
    });
    setFilteredOffers(filtered);
  }, [currentLocation, destination, type, transportOffers]);

  return (
    <div className="container mx-auto p-6">
      <h1 className="text-3xl font-bold mb-6">عروض النقل</h1>
      <Link to='/CreateTransportOfferPage' className='bg-green-500 rounded-md px-4 py-2 my-6'> 
        إنشاء عرض نقل
      </Link>

      <div className="flex flex-wrap justify-between my-6">
        <input
          type="text"
          placeholder="أدخل الموقع الحالي"
          value={currentLocation}
          onChange={(e) => setCurrentLocation(e.target.value)}
          className="p-2 border border-gray-300 rounded-md mb-4 w-full sm:w-1/3"
        />
        <input
          type="text"
          placeholder="أدخل الوجهة"
          value={destination}
          onChange={(e) => setDestination(e.target.value)}
          className="p-2 border border-gray-300 rounded-md mb-4 w-full sm:w-1/3"
        />
        <select
          value={type}
          onChange={(e) => setType(e.target.value)}
          className="p-2 border border-gray-300 rounded-md mb-4 w-full sm:w-1/3"
        >
          <option value="">اختر نوع النقل</option>
          <option value="Car">سيارة</option>
          <option value="Bus">حافلة</option>
          <option value="Plane">طائرة</option>
          <option value="Train">قطار</option>
        </select>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-6">
        {filteredOffers.length > 0 ? (
          filteredOffers.map((offer) => (
            <div key={offer.id} className="bg-white p-6 rounded-lg shadow-lg">
              <h2 className="text-2xl font-semibold">{offer.origin} إلى {offer.destination}</h2>
              <p>{offer.type}</p>
              <p>التكلفة: دج{offer.cost}</p>
              <p>الوقت: {offer.time}</p>
            </div>
          ))
        ) : (
          <p>لم يتم العثور على عروض نقل.</p>
        )}
      </div>

      <div className="w-full h-96">
        <LoadScript googleMapsApiKey="YOUR_GOOGLE_MAPS_API_KEY">
          <GoogleMap
            mapContainerStyle={{ width: '100%', height: '100%' }}
            center={mapCenter}
            zoom={mapZoom}
          >
            {filteredOffers.map((offer) => (
              <Marker
                key={offer.id}
                position={{ lat: offer.lat, lng: offer.lng }}
                title={`${offer.origin} إلى ${offer.destination}`}
              />
            ))}
          </GoogleMap>
        </LoadScript>
      </div>
    </div>
  );
};

export default TransportOffersPage;
